import { initChoices } from '../utils/select';
import CustomFile from "../utils/customFile";

export default class Contact {
    constructor(query) {
        this.el = document.querySelector(query);
        if (!this.el) return;

        this.tabs = this.el.querySelectorAll('[data-contact-tab]');
        this.forms = this.el.querySelectorAll('[data-contact-form]');
        this.fileFields = this.el.querySelectorAll('[data-custom-file]');
        this.init();
    }

    init() {
        this.initTabs();
        // this.initFiles();
        this.customFile = new CustomFile(this.el);
        this.customFile.init();
        this.initCf7Events();
        initChoices('.js-select');
    }

    initTabs() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const index = tab.getAttribute('data-contact-tab');

                this.tabs.forEach((item) => item.classList.remove('active'));
                this.forms.forEach((item) => item.classList.remove('active', 'is-success'));

                tab.classList.add('active');

                const form = this.el.querySelector(`[data-contact-form="${index}"]`);
                if (form) form.classList.add('active');
            });
        });
    }

    initFiles() {
        this.fileFields.forEach((field) => {
            const input = field.querySelector('input[type="file"]');
            if (!input) return;

            const ui = document.createElement('div');
            ui.className = 'custom-file__ui';

            ui.innerHTML = `
                <div class="custom-file__default">
                    <div class="site-text secondary custom-file__title">Upload Your CV</div>
                    <div class="site-text secondary custom-file__text">
                        Drag & drop your files here or click to browse.<br>
                        Supported formats: PDF, DOC/DOCX
                    </div>
                    <div class="custom-file__button" type="button">Browse Files</div>
                </div>
                <div class="custom-file__dragover">
                    <div class="site-text secondary custom-file__title">Drop your file to upload</div>
                    <div class="site-text secondary custom-file__text">PDF, DOC/DOCX up to 10MB</div>
                </div>
                <div class="custom-file__uploading">
                    <div class="custom-file__box">
                        <div>
                            <div class="custom-file__upload-name"></div>
                            <div class="custom-file__upload-size"></div>
                        </div>
                        <div class="custom-file__remove" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M15 5L5 15M5 5L15 15" stroke="#F8F9FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </div>
                    </div>

                    <div class="custom-file__progress">
                        <span></span>
                    </div>

                    <div class="custom-file__progress-text">Uploading... 0%</div>
                </div>
                <div class="custom-file__success">
                    <div class="custom-file__box">
                        <div class="custom-file__box-text">
                            <div class="custom-file__name"></div>
                            <div class="custom-file__size"></div>
                        </div>
                        <div class="custom-file__icon" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M16.6693 5L7.5026 14.1667L3.33594 10" stroke="#78D6C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </div>
                    </div>
                    <div class="custom-file__replace" type="button">
                    <span>Replace file</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.3359 1.33337L14.0026 4.00004L11.3359 6.66671" stroke="#3B83FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 7.33333V6.66667C2 5.95942 2.28095 5.28115 2.78105 4.78105C3.28115 4.28095 3.95942 4 4.66667 4H14M4.66667 14.6667L2 12L4.66667 9.33333" stroke="#3B83FF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14 8.66675V9.33341C14 10.0407 13.719 10.7189 13.219 11.219C12.7189 11.7191 12.0406 12.0001 11.3333 12.0001H2" stroke="#3B83FF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div class="custom-file__error">
                    <div class="site-text secondary custom-file__title">File type not supported</div>
                    <div class="site-text secondary custom-file__text">PDF, DOC/DOCX up to 10MB</div>
                    <div class="custom-file__button" type="button">Browse Files</div>
                </div>
            `;


            field.appendChild(ui);

            const buttons = field.querySelectorAll('.custom-file__button, .custom-file__replace');
            const remove = field.querySelector('.custom-file__remove');
            const name = field.querySelector('.custom-file__name');
            const size = field.querySelector('.custom-file__size');

            const uploadName = field.querySelector('.custom-file__upload-name');
            const uploadSize = field.querySelector('.custom-file__upload-size');
            const progress = field.querySelector('.custom-file__progress span');
            const progressText = field.querySelector('.custom-file__progress-text');

            buttons.forEach((button) => {
                button.addEventListener('click', () => input.click());
            });

            input.addEventListener('change', () => {
                this.setFile(field, input, name, size, uploadName, uploadSize, progress, progressText);
            });

            remove.addEventListener('click', () => {
                input.value = '';
                input.classList.remove('wpcf7-not-valid');
                input.setAttribute('aria-invalid', 'false');
                field.classList.remove('has-file', 'is-error', 'is-required-error', 'is-uploading');

                if (field.uploadTimer) {
                    clearInterval(field.uploadTimer);
                }

                field.classList.remove('has-file', 'is-error', 'is-required-error', 'is-uploading');
            });

            ['dragenter', 'dragover'].forEach((eventName) => {
                field.addEventListener(eventName, (event) => {
                    event.preventDefault();
                    field.classList.add('is-dragover');
                });
            });

            ['dragleave', 'drop'].forEach((eventName) => {
                field.addEventListener(eventName, (event) => {
                    event.preventDefault();
                    field.classList.remove('is-dragover');
                });
            });

            field.addEventListener('drop', (event) => {
                const { files } = event.dataTransfer;
                if (!files.length) return;

                input.files = files;
                this.setFile(field, input, name, size, uploadName, uploadSize, progress, progressText);
            });
        });
    }

    initCf7Events() {
        document.addEventListener('wpcf7invalid', () => {
            setTimeout(() => {
                this.fileFields.forEach((field) => {
                    const input = field.querySelector('input[type="file"]');
                    if (!input) return;

                    if (input.classList.contains('wpcf7-not-valid')) {
                        field.classList.add('is-required-error');
                    } else {
                        field.classList.remove('is-required-error');
                    }
                });
            }, 0);
        });

        document.addEventListener('wpcf7mailsent', (event) => {
            const formElement = event.target;
            const contactForm = formElement.closest('[data-contact-form]');

            if (contactForm) {
                contactForm.classList.add('is-success');
            }

            this.fileFields.forEach((field) => {
                const input = field.querySelector('input[type="file"]');
                const name = field.querySelector('.custom-file__name');
                const size = field.querySelector('.custom-file__size');

                if (input) input.value = '';
                if (name) name.textContent = '';
                if (size) size.textContent = '';

                field.classList.remove('has-file', 'is-error', 'is-required-error', 'is-dragover', 'is-uploading');
            });

            this.fileFields.forEach((field) => {
                const input = field.querySelector('input[type="file"]');
                const name = field.querySelector('.custom-file__name');
                const size = field.querySelector('.custom-file__size');

                if (input) input.value = '';
                if (name) name.textContent = '';
                if (size) size.textContent = '';

                field.classList.remove('has-file', 'is-error', 'is-required-error', 'is-dragover');
            });
        });
    }

    setFile(field, input, name, size, uploadName, uploadSize, progress, progressText) {
        const file = input.files[0];
        if (!file) return;

        const validTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        input.classList.remove('wpcf7-not-valid');
        input.setAttribute('aria-invalid', 'false');
        field.classList.remove('is-required-error');

        const tip = field.querySelector('.wpcf7-not-valid-tip');
        if (tip) tip.remove();

        if (!validTypes.includes(file.type) || file.size > 10 * 1024 * 1024) {
            input.value = '';
            field.classList.remove('has-file', 'is-uploading');
            field.classList.add('is-error');
            return;
        }

        const fileSize = `${(file.size / 1024 / 1024).toFixed(1)} MB`;

        name.textContent = file.name;
        size.textContent = fileSize;
        uploadName.textContent = file.name;
        uploadSize.textContent = fileSize;

        field.classList.remove('has-file', 'is-error', 'is-required-error');
        field.classList.add('is-uploading');

        let value = 0;

        if (field.uploadTimer) {
            clearInterval(field.uploadTimer);
        }

        progress.style.width = '0%';
        progressText.textContent = 'Uploading... 0%';

        field.uploadTimer = setInterval(() => {
            value += Math.floor(Math.random() * 12) + 8;

            if (value >= 100) {
                value = 100;
            }

            progress.style.width = `${value}%`;
            progressText.textContent = `Uploading... ${value}%`;

            if (value === 100) {
                clearInterval(field.uploadTimer);

                setTimeout(() => {
                    field.classList.remove('is-uploading');
                    field.classList.add('has-file');
                }, 200);
            }
        }, 120);
    }
}